// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleView_wrapper__1j8fQ","col":"ToggleView_col__XlElQ","active":"ToggleView_active__96bj8"};